import "./VentilatorMonitoringVitalsMobileView.scss";
import { ACTIVE_PARAMETERS, PARAMETER_UNIT_IDS} from '../../common/ENUMS/PARAMETER_ENUM';
import { alarmBackground } from '../../common/utils/CommonUtils';
import { formatValue } from '../../common/utils/CommonUtils.js';

const VentilatorMonitoringVitalsMobileView = ({
    visibleParameters,
}) => {

    console.log("visibleParameters", visibleParameters)

    return (
        <div className="ventilator-monitoring-vitals-mobile-view">
            {visibleParameters?.map((paramData) => {

                const hasValidUnit =
                    PARAMETER_UNIT_IDS?.[paramData?.unit]?.UNIT != null;

                const alarmClass =
                    hasValidUnit && paramData?.alarms?.length
                        ? alarmBackground(paramData?.alarms)
                        : "";

                const title =
                    ACTIVE_PARAMETERS?.[paramData?.id]?.TITLE ?? null;

                // 🚀 Skip box if title invalid
                if (!title) return null;

                const unit =
                    hasValidUnit
                        ? PARAMETER_UNIT_IDS?.[paramData?.unit]?.UNIT ?? "-"
                        : "-";

                const value =
                    hasValidUnit && paramData?.value != null
                        ? formatValue(
                            paramData?.id,
                            paramData?.value,
                            paramData?.precision
                        )
                        : "-";

                return (
                    <div
                        key={paramData?.id}
                        className={`vital-box ${alarmClass}`}
                    >
                        <div className={`vital-box-title ${alarmClass}`}>
                            {title}
                        </div>

                        <div
                            className={`vital-box-value ${alarmClass}`}
                        >
                            {value}
                        </div>

                        <div className={`vital-box-unit ${alarmClass}`}>
                            {unit}
                        </div>
                    </div>
                );
            })}
        </div>

    )

};

export default VentilatorMonitoringVitalsMobileView;